import Dropdown from '@cobliteam/ui/components/Dropdown';
import Typography from '@cobliteam/ui/components/Typography';
import type { LegendItem } from './items';

interface MapLegendOverlayProps {
  legendItems: LegendItem[];
}

const MapLegendOverlay = ({ legendItems }: MapLegendOverlayProps) => {
  return (
    <Dropdown.Overlay className='w-fit'>
      <Dropdown.Body className='my-0 max-h-full px-2.5 py-0'>
        {legendItems.map(({ Icon, description }) => (
          <div key={description} className='flex items-center gap-2'>
            <div className='w-8'>
              <Icon />
            </div>
            <Typography variant='caption-default'>{description}</Typography>
          </div>
        ))}
      </Dropdown.Body>
    </Dropdown.Overlay>
  );
};

export default MapLegendOverlay;
